import React, {Component} from 'react';
import './main_menu_content.scss';
import {RESTRICTED_EN_VALUES, RESTRICTED_IT_VALUES} from '../../../config/restrictedValues';
import {chunk} from "../../../utils/utils";

class MainMenuContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            buttonTitle: this.props.buttonTitle,
            pages: this.props.data[this.props.buttonTitle]
        };
    }

    componentDidMount() {
        this.setData(this.props.buttonTitle);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.buttonTitle !== nextProps.buttonTitle) {
            this.setData(nextProps.buttonTitle);
        }
        return true;
    }

    setData(buttonTitle) {
        let data = this.props.data;
        this.setState({
            buttonTitle: buttonTitle,
            pages: data[buttonTitle]
        })
    }

    render() {
        let componentData = this.state.pages.below;
        let lang = localStorage.getItem('i18nextLng');

        if (componentData !== undefined) {
            let getSecondAndThirdLevelTitle = (value) => {
                for (let i = 0; i < componentData.length; i++) {
                    if (componentData[i].title === value) componentData.splice(i, 1);


                    if (componentData[i] !== undefined && componentData[i].below) {
                        let thirdLevelData = componentData[i].below;
                        for (let x = 0; x < thirdLevelData.length; x++) {
                            if (thirdLevelData[x].title === value) thirdLevelData.splice(x, 1);
                        }
                    }
                }
            };

            if (lang === 'en') {
                RESTRICTED_EN_VALUES.forEach(getSecondAndThirdLevelTitle);
            } else if (lang === 'it') {
                RESTRICTED_IT_VALUES.forEach(getSecondAndThirdLevelTitle);
            }



            const size = componentData.length / 3;
            let array = chunk(componentData, Math.ceil(size));

            // Creating 3 different arrays
            const firstArray = array[0];
            const secondArray = array[1];
            const thirdArray = array[2];

            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <ul className="content-list">
                                {firstArray && firstArray.map((mainPage, index) => (
                                    <li key={index}>
                                        <div className="paragraph-separator">
                                            <a className="content-list-link" href={mainPage.relative}>{mainPage.title}</a>
                                            <ul className="content-sublist">
                                                {mainPage.below && mainPage.below.map((subpage, indexB) => (
                                                    <li key={indexB} className="content-line-style">
                                                        <a className="content-sublist-link"
                                                           href={subpage.relative}>{subpage.title}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col">
                            <ul className="content-list">
                                {secondArray ? secondArray.map((mainPage, index) => (
                                    <li key={index}>
                                        <div className="paragraph-separator">
                                            <a className="content-list-link" href={mainPage.relative}>{mainPage.title}</a>
                                            <ul className="content-sublist">
                                                {mainPage.below ? mainPage.below.map((subpage, indexB) => (
                                                    <li key={indexB} className="content-line-style">
                                                        <a className="content-sublist-link"
                                                           href={subpage.relative}>{subpage.title}</a>
                                                    </li>
                                                )) : null}
                                            </ul>
                                        </div>
                                    </li>
                                )) : null}
                            </ul>
                        </div>
                        <div className="col">
                            <ul className="content-list">
                                {thirdArray && thirdArray.map((mainPage, index) => (
                                    <li key={index}>
                                        <div className="paragraph-separator">
                                            <a className="content-list-link" href={mainPage.relative}>{mainPage.title}</a>
                                            <ul className="content-sublist">
                                                {mainPage.below && mainPage.below.map((subpage, indexB) => (
                                                    <li key={indexB} className="content-line-style">
                                                        <a className="content-sublist-link"
                                                           href={subpage.relative}>{subpage.title}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (<div/>);
        }
    }
}

export default MainMenuContent;
